import styled from "styled-components";

export const StiledMain = styled.main`
	/* --------------- rule for pressing the footer to the bottom --------------- */
	/* min-height: 100%;
	display: grid;
	grid-template-rows: auto 1fr auto; */
`;
